module.exports = __webpack_public_path__ + "static/media/music.75c4bc1.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sound/music.mp3
// module id = 155
// module chunks = 1